import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import FormLevel from "./components/formLevel"
import { useTranslation } from "react-i18next"
import { DraggableList } from "./components/draggableList"
import { DraggableItem } from "./components/draggableItem/types"
import { NoResponse } from "../../../../../../../../components/errors/noResponse"
import { memo } from "react"


const CatalogOption = ({ children, parentId, depth, rootId, level, id, showText, subCatalogId }: { subCatalogId?:number; showText?: boolean; id: string; level: number; rootId?: string; children?: DraggableItem[], parentId?: string | null; depth: number; }) => {

    const styles = useStyles()
    const { t } = useTranslation()


    return (
        <Box sx={styles.container(depth % 2 === 0, level === 1, level == 2)}>
            {!parentId && <Typography sx={styles.title}>{t('catalog.catalogServices')}</Typography>}

            <FormLevel subCatalogId={subCatalogId} rootId={rootId ?? ''} id={id} level={level} parentId={parentId ?? null} hasChild={!!children?.length} />

            {
                parentId ?
                    <DraggableList
                        parentId={parentId}
                        items={children || []}
                        depth={depth}
                        rootId={rootId ?? ''}
                        level={level}
                    />
                    :
                    <>
                        {(children ?? [])?.length > 0 ?
                            <DraggableList
                                parentId={parentId}
                                items={children || []}
                                depth={depth}
                                rootId={rootId ?? ''}
                                level={level}
                            />
                            :
                            <Box sx={styles.notContainer}>
                                {showText && <NoResponse label={t('catalog.noCatalog')} />}
                            </Box>
                        }
                    </>
            }

        </Box>
    )
}

export default memo(CatalogOption)